export default __webpack_public_path__ + "static/media/Window.3f0706a6.less";